import { render, staticRenderFns } from "./NumberItem.vue?vue&type=template&id=646bb322&"
import script from "./NumberItem.vue?vue&type=script&lang=js&"
export * from "./NumberItem.vue?vue&type=script&lang=js&"
import style0 from "./NumberItem.vue?vue&type=style&index=0&id=646bb322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports